import create from 'zustand';
import {flatDeep} from 'utils/ArrayUtils';
import {logHelper, tLogStyled} from 'utils/Logger';
import {FSMStates} from 'webgl/types/FSMStates';

// TODO should move this store in src/stores/ ?

const _initialState = FSMStates.notLoaded;

export type FSMStoreProps = {
  currentFSMState?: string;
  currentFSMStateSiblings: string[];
  fsmStateStack: string[];

  setFSMState: (nextState: string, ignoreStack?: boolean) => void;
  setPreviousFSMState: () => void;

  overrideNextState?: string;
  setOverrideNextState: (overrideState?: string) => void;

  isSubStateOf: (parentFSMState: string | Record<string, unknown>) => boolean;
  // getParentStateOf: (state: string) => {[key: string]: string};
  getSiblingStates: (state?: string/*, includeSelf?: boolean*/) => string[];
  stateExists: (state?: string) => boolean;
};

export const FSMStore = create<FSMStoreProps>((set, get) => ({
  currentFSMState: _initialState,
  currentFSMStateSiblings: [],
  fsmStateStack: [_initialState],

  setFSMState: (newState, ignoreStack = false) => {
    const stateStack = [...get().fsmStateStack];
    // set({currentFSMState: newState});

    tLogStyled(`[FSMStore] SetState ${newState} ` /*+ `${ignoreStack ? '(ignoring FSM stack)' : ''}`*/, logHelper.event); // DEBUG

    if (newState != null) {
      // OnExit Global Event

      // TODO hack to go to previous state if fullpage
      // if (ignoreStack) stateStack.push(stateStack[stateStack.length-1]);
      // else stateStack.push(newState);

      stateStack.push(newState);
      const siblings = get().getSiblingStates(newState);
      set({currentFSMState: newState, fsmStateStack: stateStack, currentFSMStateSiblings: siblings});
      // OnEnter Global Event
    }
  },

  setPreviousFSMState: () => {
    const stateStack = [...get().fsmStateStack];
    if (stateStack.length > 1) {
      stateStack.pop(); // Remove last state (the current one)
      const prevState = stateStack.pop() || '';
      set({fsmStateStack: stateStack}); // TODO remove this line to add previous state to the stack without removing the previous ones (don't work with fullpage close buttons)
      get().setFSMState(prevState);
    }
  },

  overrideNextState: undefined,
  setOverrideNextState: (overrideState?: string) => set({overrideNextState: overrideState}),

  isSubStateOf: (parentFSMState) => {

    // current state is a string like 'guidedVisit.aaa.bbb'
    const {currentFSMState, isSubStateOf} = get();

    if (typeof parentFSMState === 'object') {

      return Object.keys(parentFSMState).some(key => {
        if (typeof parentFSMState[key] === 'object') {
          // @ts-expect-error can't assign undefined to Record because of missing type
          return isSubStateOf(parentFSMState[key]);
        } else {

          return parentFSMState[key] === currentFSMState;
        }
      });

    } else {
      return parentFSMState === currentFSMState;
    }
  },

  getSiblingStates: (state/*, includeSelf = false*/) => {
    if (!state) return [];

    const splitState = state.split('.');
    splitState.pop(); // remove last item
    if (splitState.length >= 1) {
      // @ts-ignore
      const siblings = Object.values(splitState.reduce((acc, cur) => acc[cur], FSMStates))
        .filter(sib => typeof sib === 'string'); //.filter(sib => includeSelf ? true : sib !== state);

      return siblings as string[];
    }
    return [];
  },

  stateExists: (state) => {
    const flattenStates = (states: { [k: string]: any }): any[] =>
      flatDeep(Object.values(states).map(_state => {
        if (typeof _state !== 'string') {
          return flattenStates(_state);
        } else {
          return _state;
        }
      }));

    const _flatStates = flattenStates(FSMStates);
    return _flatStates.includes(state);
  }
}));
